import type { TranslationKey } from '@/lib/i18n';

export const LOGIN_PAGE_TITLE = [
  'common:login_page.title',
  'Log In to Your Account',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_STATUS_SIGNING_IN = [
  'common:login_page.signing_in',
  'Signing you in…',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_MAGIC_LINK_SENT = [
  'common:login_page.magic_link_sent',
  'Check your email. We sent a one-time link to sign in.',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_LABEL_EMAIL = [
  'common:login_page.email_label',
  'Email:',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_PLACEHOLDER_EMAIL = [
  'common:login_page.email_placeholder',
  'email@example.com',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_LABEL_PASSWORD = [
  'common:login_page.password_label',
  'Password:',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_PLACEHOLDER_PASSWORD = [
  'common:login_page.password_placeholder',
  'Enter your password',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_CTA_PASSWORD_INSTEAD = [
  'common:login_page.sign_in_password_instead',
  'Sign in with your password instead',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_CTA_CONTINUE_EMAIL = [
  'common:login_page.continue_with_email',
  'Continue with email',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_TEXT_NO_ACCOUNT = [
  'common:login_page.no_account',
  "Don't have an account yet?",
] as const satisfies TranslationKey;

export const LOGIN_PAGE_LINK_SIGN_UP = [
  'common:login_page.sign_up_here',
  'Sign up here.',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_CTA_GOOGLE = [
  'common:login_page.sign_in_google',
  'Sign in with Google',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFITS_TITLE = [
  'common:login_page.benefits_title',
  'Sign up to access exclusive features',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFIT_MANAGE_YOUR = [
  'common:login_page.benefit_manage_your',
  'Manage your',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFIT_SUBSCRIPTIONS = [
  'common:login_page.benefit_subscriptions',
  'subscriptions',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFIT_EXCHANGES = [
  'common:login_page.benefit_exchanges',
  'Exchanges &',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFIT_RETURNS = [
  'common:login_page.benefit_returns',
  'Returns',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFIT_TRACK_YOUR = [
  'common:login_page.benefit_track_your',
  'Track your',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFIT_ORDER = [
  'common:login_page.benefit_order',
  'order',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFIT_ACCESS_LIMITED = [
  'common:login_page.benefit_access_limited',
  'Access limited-',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_BENEFIT_TIME_OFFERS = [
  'common:login_page.benefit_time_offers',
  'time offers',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_ACCESSIBILITY_SCROLL_TOP = [
  'common:login_page.scroll_to_top_aria',
  'Scroll to top',
] as const satisfies TranslationKey;

export const LOGIN_PAGE_CTA_SCROLL_TOP = [
  'common:login_page.scroll_to_top',
  'SCROLL TO TOP',
] as const satisfies TranslationKey;

export const REGISTER_PAGE_TITLE = [
  'common:register_page.title',
  'Sign Up',
] as const satisfies TranslationKey;

export const REGISTER_PAGE_SUBTITLE = [
  'common:register_page.subtitle',
  'Enter your email to sign up.',
] as const satisfies TranslationKey;

export const REGISTER_PAGE_MAGIC_LINK_SENT = [
  'common:register_page.magic_link_sent',
  'Check your email. We sent a one-time link to create your account and sign in.',
] as const satisfies TranslationKey;

export const REGISTER_PAGE_LABEL_EMAIL = [
  'common:register_page.email_label',
  'Email:',
] as const satisfies TranslationKey;

export const REGISTER_PAGE_PLACEHOLDER_EMAIL = [
  'common:register_page.email_placeholder',
  'email@example.com',
] as const satisfies TranslationKey;

export const REGISTER_PAGE_TEXT_HAVE_ACCOUNT = [
  'common:register_page.have_account',
  'Already have an account?',
] as const satisfies TranslationKey;

export const REGISTER_PAGE_LINK_LOG_IN = [
  'common:register_page.log_in_here',
  'Log in here.',
] as const satisfies TranslationKey;

export const COMPLETE_PROFILE_PAGE_TITLE = [
  'common:complete_profile_page.title',
  'Complete your profile',
] as const satisfies TranslationKey;

export const COMPLETE_PROFILE_PAGE_DESCRIPTION = [
  'common:complete_profile_page.description',
  'We need your first and last name to continue. Phone number is optional.',
] as const satisfies TranslationKey;

export const COMPLETE_PROFILE_PAGE_LABEL_FIRST_NAME = [
  'common:complete_profile_page.first_name',
  'First name',
] as const satisfies TranslationKey;

export const COMPLETE_PROFILE_PAGE_LABEL_LAST_NAME = [
  'common:complete_profile_page.last_name',
  'Last name',
] as const satisfies TranslationKey;

export const COMPLETE_PROFILE_PAGE_LABEL_EMAIL = [
  'common:complete_profile_page.email',
  'Email',
] as const satisfies TranslationKey;

export const COMPLETE_PROFILE_PAGE_LABEL_PHONE = [
  'common:complete_profile_page.phone_optional',
  'Phone (optional)',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LOADING = [
  'common:my_account.loading',
  'Loading...',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_BREADCRUMB_HOME = [
  'common:my_account.breadcrumb_home',
  'Home',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_BREADCRUMB_TITLE = [
  'common:my_account.breadcrumb_title',
  'My Account',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_ACCESSIBILITY_ACCOUNT_NAV = [
  'common:my_account.account_nav_aria',
  'Account navigation',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_CTA_SIGN_OUT = [
  'common:my_account.sign_out',
  'Sign out',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_GREETING = [
  'common:my_account.greeting',
  'Hi {{name}}',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_ACCESSIBILITY_EDIT_PROFILE = [
  'common:my_account.edit_profile_aria',
  'Edit profile',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_ACCOUNT_OVERVIEW = [
  'common:my_account.account_overview',
  'Account Overview',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_MY_PURCHASES = [
  'common:my_account.my_purchases',
  'My Purchases',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_CTA_SEE_ALL = [
  'common:my_account.see_all',
  'See All',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LOADING_ORDERS = [
  'common:my_account.loading_orders',
  'Loading orders...',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_EMPTY_NO_PURCHASES = [
  'common:my_account.no_purchases',
  "You haven't made any purchases yet.",
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_SHIPPING_ADDRESSES = [
  'common:my_account.shipping_addresses',
  'Shipping addresses',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_PHONE_NUMBER = [
  'common:my_account.phone_number',
  'Phone number:',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_EMPTY_NO_ADDRESSES_PREVIEW = [
  'common:my_account.no_addresses_preview',
  'No shipping addresses saved yet.',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_ACCESSIBILITY_GO_BACK = [
  'common:my_account.go_back_aria',
  'Go back',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_ADD_NEW_SHIPPING_ADDRESS = [
  'common:my_account.add_new_shipping_address',
  'Add New Shipping Address',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_FIRST_NAME = [
  'common:my_account.first_name',
  'First Name',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_LAST_NAME = [
  'common:my_account.last_name',
  'Last Name',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_ADDRESS_1 = [
  'common:my_account.address_1',
  'Address 1',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_ADDRESS_2_OPTIONAL = [
  'common:my_account.address_2_optional',
  'Apt, suite, etc. (optional)',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_CITY = [
  'common:my_account.city',
  'City',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_ZIP_CODE = [
  'common:my_account.zip_code',
  'Zip Code',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_STATE = [
  'common:my_account.state',
  'State',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_COUNTRY = [
  'common:my_account.country',
  'Country',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_UNITED_STATES = [
  'common:my_account.united_states',
  'United States',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_PHONE = [
  'common:my_account.phone',
  'Phone',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_SHIPPING_ADDRESS = [
  'common:my_account.shipping_address',
  'Shipping Address',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LOADING_ADDRESSES = [
  'common:my_account.loading_addresses',
  'Loading addresses...',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_EMPTY_NO_SAVED_ADDRESSES = [
  'common:my_account.no_saved_addresses',
  'You currently have no saved addresses. Get started by adding one!',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_CTA_ADD_NEW_SHIPPING_ADDRESS = [
  'common:my_account.add_new_shipping_address_cta',
  'ADD NEW SHIPPING ADDRESS',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_ACCESSIBILITY_DEFAULT_SHIPPING_ADDRESS = [
  'common:my_account.default_shipping_address_aria',
  'Default shipping address',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_CTA_ADD_SHIPPING_ADDRESS = [
  'common:my_account.add_shipping_address',
  'Add new shipping address',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_PURCHASES_HISTORY = [
  'common:my_account.purchases_history',
  'Purchases History',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_EXCHANGES_RETURNS = [
  'common:my_account.exchanges_returns',
  'Exchanges & Returns',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_EMPTY_NO_REFUND_ORDERS = [
  'common:my_account.no_refund_orders',
  'No eligible orders found for a refund.',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_SELECT_ORDER = [
  'common:my_account.select_order',
  'Select Order',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_PLACEHOLDER_CHOOSE_ORDER = [
  'common:my_account.choose_order',
  '-- Choose an order --',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LOADING_ORDER_DETAILS = [
  'common:my_account.loading_order_details',
  'Loading order details...',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_REFUND_TYPE = [
  'common:my_account.refund_type',
  'Refund Type',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_REFUND_MODE_ITEMS = [
  'common:my_account.refund_mode_items',
  'Items',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_REFUND_MODE_SHIPPING = [
  'common:my_account.refund_mode_shipping',
  'Shipping',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_REFUND_MODE_AMOUNT = [
  'common:my_account.refund_mode_amount',
  'Amount',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_SELECT_ITEMS_REFUND = [
  'common:my_account.select_items_refund',
  'Select Items to Refund',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_SHIPPING_REFUND = [
  'common:my_account.shipping_refund',
  'Shipping Refund',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_MSG_SHIPPING_ALREADY_REFUNDED = [
  'common:my_account.shipping_already_refunded',
  'Shipping has already been refunded for this order.',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_SHIPPING_COST = [
  'common:my_account.shipping_cost',
  'Shipping cost',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_CUSTOM_AMOUNT = [
  'common:my_account.custom_amount',
  'Custom Amount',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_REFUNDABLE_BALANCE = [
  'common:my_account.refundable_balance',
  'Refundable balance:',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_REASON = [
  'common:my_account.reason',
  'Reason',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_ADDITIONAL_DETAILS = [
  'common:my_account.additional_details',
  'Additional Details (optional)',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_PLACEHOLDER_REFUND_DETAILS = [
  'common:my_account.refund_details_placeholder',
  "Tell us more about why you'd like a refund...",
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_REFUND_HISTORY = [
  'common:my_account.refund_history',
  'Refund History',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_TRACK_MY_ORDER = [
  'common:my_account.track_my_order',
  'Track My Order',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_MY_CREDITS = [
  'common:my_account.my_credits',
  'My Credits',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LOADING_CREDITS = [
  'common:my_account.loading_credits',
  'Loading credits...',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_AVAILABLE_CREDITS = [
  'common:my_account.available_credits',
  'Available Credits',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_CREDIT_VALUE = [
  'common:my_account.credit_value',
  '1 credit = $1.00',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_TRANSACTION_HISTORY = [
  'common:my_account.transaction_history',
  'Transaction History',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_EMPTY_NO_CREDIT_TRANSACTIONS = [
  'common:my_account.no_credit_transactions',
  'No credit transactions yet. Credits are earned through purchases and promotions.',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_BALANCE = [
  'common:my_account.balance',
  'Balance: $',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_TITLE_COUPONS = [
  'common:my_account.coupons',
  'Coupons',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LOADING_COUPONS = [
  'common:my_account.loading_coupons',
  'Loading coupons...',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_AVAILABLE_COUPONS = [
  'common:my_account.available_coupons',
  'Available Coupons',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_EMPTY_NO_AVAILABLE_COUPONS = [
  'common:my_account.no_available_coupons',
  'No available coupons right now. Check back later!',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_USED_COUPONS = [
  'common:my_account.used_coupons',
  'Used Coupons',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_EMPTY_NO_USED_COUPONS = [
  'common:my_account.no_used_coupons',
  "You haven't used any coupons yet.",
] as const satisfies TranslationKey;

export const MY_ACCOUNT_LABEL_USED = [
  'common:my_account.used',
  'Used',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_COUPON_APPLIED = [
  'common:my_account.coupon_applied',
  '{{name}} · Applied {{date}}',
] as const satisfies TranslationKey;

export const MY_ACCOUNT_COMING_SOON = [
  'common:my_account.coming_soon',
  'This section is coming soon!',
] as const satisfies TranslationKey;

export const ABOUT_PAGE_TITLE = [
  'common:about_page.title',
  'About Shapermint',
] as const satisfies TranslationKey;

export const ABOUT_PAGE_HERO_TEXT = [
  'common:about_page.hero_text',
  'Shapermint',
] as const satisfies TranslationKey;

export const ABOUT_PAGE_MISSION = [
  'common:about_page.mission',
  'Shapermint is on a mission to help every woman feel confident and comfortable in her own skin. We believe that shapewear should empower, not restrict — and that every body deserves to feel amazing.',
] as const satisfies TranslationKey;

export const ABOUT_PAGE_STORY_TITLE = [
  'common:about_page.story_title',
  'Our Story',
] as const satisfies TranslationKey;

export const ABOUT_PAGE_STORY_BODY = [
  'common:about_page.story_body',
  'Founded with the simple idea that shapewear could be better, Shapermint has grown into a community of over 5 million women who share our vision of comfort, confidence, and self-love. We work tirelessly to create products that combine innovative design with everyday wearability.',
] as const satisfies TranslationKey;

export const ABOUT_PAGE_PROMISE_TITLE = [
  'common:about_page.promise_title',
  'Our Promise',
] as const satisfies TranslationKey;

export const ABOUT_PAGE_PROMISE_BODY = [
  'common:about_page.promise_body',
  "Every Shapermint product is designed with you in mind. From our wireless shaping bras to our seamless leggings, we use premium materials and thoughtful construction to deliver shapewear you'll actually want to wear — all day, every day.",
] as const satisfies TranslationKey;

export const ABOUT_PAGE_MOVEMENT_TITLE = [
  'common:about_page.movement_title',
  'Join the Movement',
] as const satisfies TranslationKey;

export const ABOUT_PAGE_MOVEMENT_BODY = [
  'common:about_page.movement_body',
  "We're more than a brand — we're a movement. Join millions of women around the world who have discovered the Shapermint difference. Because feeling great should never be a compromise.",
] as const satisfies TranslationKey;

export const CART_PAGE_TITLE = [
  'common:cart_page.title',
  'Your Cart',
] as const satisfies TranslationKey;

export const CART_PAGE_EMPTY = [
  'common:cart_page.empty',
  'Your cart is empty.',
] as const satisfies TranslationKey;

export const CART_PAGE_CONTINUE_SHOPPING = [
  'common:cart_page.continue_shopping',
  'Continue Shopping',
] as const satisfies TranslationKey;

export const CART_PAGE_QTY = [
  'common:cart_page.qty',
  'Qty: {{count}}',
] as const satisfies TranslationKey;

export const CART_PAGE_SUBTOTAL = [
  'common:cart_page.subtotal',
  'Subtotal ({{count}} items)',
] as const satisfies TranslationKey;

export const CART_PAGE_SHIPPING = [
  'common:cart_page.shipping',
  'Shipping',
] as const satisfies TranslationKey;

export const CART_PAGE_TOTAL = [
  'common:cart_page.total',
  'Total',
] as const satisfies TranslationKey;

export const CART_PAGE_PROCEED_CHECKOUT = [
  'common:cart_page.proceed_checkout',
  'Proceed to Checkout',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_TITLE = [
  'common:checkout_page.title',
  'Checkout',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_LOADING_CART = [
  'common:checkout_page.loading_cart',
  'Loading your cart...',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_EMPTY_CART = [
  'common:checkout_page.empty_cart',
  'Your cart is empty.',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_CONTINUE_SHOPPING = [
  'common:checkout_page.continue_shopping',
  'Continue Shopping',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_ORDER_SUMMARY = [
  'common:checkout_page.order_summary',
  'Order summary — {{count}} items',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_QTY = [
  'common:checkout_page.qty',
  'Qty: {{count}}',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_TOTAL = [
  'common:checkout_page.total',
  'Total',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_REDIRECTING = [
  'common:checkout_page.redirecting',
  'Redirecting to secure checkout...',
] as const satisfies TranslationKey;

export const CHECKOUT_PAGE_BACK_CONTINUE_SHOPPING = [
  'common:checkout_page.back_continue_shopping',
  '← Continue Shopping',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_SORT_BY = [
  'common:collection_detail.sort_by',
  'Sort By',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_SORT_ARIA = [
  'common:collection_detail.sort_aria',
  'Sort',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_SORT_BEST_SELLING = [
  'common:collection_detail.sort_best_selling',
  'Best Selling',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_SORT_PRICE_ASC = [
  'common:collection_detail.sort_price_asc',
  'Price: Low-High',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_SORT_PRICE_DESC = [
  'common:collection_detail.sort_price_desc',
  'Price: High-Low',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_SORT_NEWEST = [
  'common:collection_detail.sort_newest',
  'New Arrivals',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_ERROR_LOAD = [
  'common:collection_detail.error_load',
  'Failed to load collection:',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_BREADCRUMB_HOME = [
  'common:collection_detail.breadcrumb_home',
  'Home',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_FILTER_BY = [
  'common:collection_detail.filter_by',
  'Filter By',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_ACTIVE_FILTERS = [
  'common:collection_detail.active_filters',
  '{{count}} filters active',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_CLOSE_FILTERS = [
  'common:collection_detail.close_filters_aria',
  'Close filters',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_CLEAR_ALL = [
  'common:collection_detail.clear_all',
  'Clear All',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_APPLY = [
  'common:collection_detail.apply',
  'Apply',
] as const satisfies TranslationKey;

export const COLLECTION_DETAIL_VIEWED_PROGRESS = [
  'common:collection_detail.viewed_progress',
  "You've viewed {{viewed}} of {{total}} {{label}}",
] as const satisfies TranslationKey;

export const COLLECTIONS_PAGE_TITLE = [
  'common:collections_page.title',
  'Collections',
] as const satisfies TranslationKey;

export const COLLECTIONS_PAGE_SUBTITLE = [
  'common:collections_page.subtitle',
  'Browse our curated product collections',
] as const satisfies TranslationKey;

export const COLLECTIONS_PAGE_SEARCH_PLACEHOLDER = [
  'common:collections_page.search_placeholder',
  'Search all products...',
] as const satisfies TranslationKey;

export const COLLECTIONS_PAGE_ERROR_LOAD = [
  'common:collections_page.error_load',
  'Failed to load collections:',
] as const satisfies TranslationKey;

export const COLLECTIONS_PAGE_EMPTY_TITLE = [
  'common:collections_page.empty_title',
  'No collections yet',
] as const satisfies TranslationKey;

export const COLLECTIONS_PAGE_EMPTY_DESCRIPTION = [
  'common:collections_page.empty_description',
  'Check back soon for curated product collections.',
] as const satisfies TranslationKey;

export const COLLECTIONS_PAGE_SHOWING = [
  'common:collections_page.showing',
  'Showing {{count}} of {{total}} collections',
] as const satisfies TranslationKey;

export const EMBED_PRODUCT_INVALID_URL = [
  'common:embed_product.invalid_url',
  'Invalid product URL',
] as const satisfies TranslationKey;

export const EMBED_PRODUCT_LOADING = [
  'common:embed_product.loading',
  'Loading...',
] as const satisfies TranslationKey;

export const EMBED_PRODUCT_NOT_FOUND = [
  'common:embed_product.not_found',
  'Product not found',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_TITLE = [
  'common:feeds_page.title',
  'Public Product Feed',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_META = [
  'common:feeds_page.meta',
  'Format: Google Merchant XML · Hosted externally',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_CTA_VIEW_FEED = [
  'common:feeds_page.view_feed',
  'View / Download Feed (XML)',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_LABEL_URL = [
  'common:feeds_page.url_label',
  'URL:',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_VERSIONING_PREFIX = [
  'common:feeds_page.versioning_prefix',
  'If the feed structure changes in future, we will version it (e.g.',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_VERSIONING_SUFFIX = [
  'common:feeds_page.versioning_suffix',
  ') and keep old URLs live for a grace period.',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_NOT_CONFIGURED_PREFIX = [
  'common:feeds_page.not_configured_prefix',
  'No product feed URL has been configured. Set',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_NOT_CONFIGURED_SUFFIX = [
  'common:feeds_page.not_configured_suffix',
  'to enable the feed link.',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_DEV_HEADING = [
  'common:feeds_page.dev_heading',
  'For developers & agents',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_DEV_ENCODING = [
  'common:feeds_page.dev_encoding',
  'Encoding: UTF-8, MIME type:',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_DEV_FIELDS_PREFIX = [
  'common:feeds_page.dev_fields_prefix',
  'Fields follow Google Merchant XML specs (e.g.',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_DEV_CACHING = [
  'common:feeds_page.dev_caching',
  'Consumers should implement caching with ETag / Last-Modified if available.',
] as const satisfies TranslationKey;

export const FEEDS_PAGE_CANONICAL = [
  'common:feeds_page.canonical',
  'Canonical:',
] as const satisfies TranslationKey;

export const LANDING_PAGE_LOADING_OFFER = [
  'common:landing_page.loading_offer',
  'Loading offer...',
] as const satisfies TranslationKey;

export const LANDING_PAGE_NO_OFFERS_TITLE = [
  'common:landing_page.no_offers_title',
  'No offers available',
] as const satisfies TranslationKey;

export const LANDING_PAGE_NO_OFFERS_BODY = [
  'common:landing_page.no_offers_body',
  'There are no active promotions for this page right now.',
] as const satisfies TranslationKey;

export const LANDING_PAGE_BACK_HOME = [
  'common:landing_page.back_home',
  'Back to home',
] as const satisfies TranslationKey;

export const LANDING_PAGE_OFFER_NOT_CONFIGURED_TITLE = [
  'common:landing_page.offer_not_configured_title',
  'Offer not configured',
] as const satisfies TranslationKey;

export const LANDING_PAGE_OFFER_NOT_CONFIGURED_BODY = [
  'common:landing_page.offer_not_configured_body',
  'This promotion is missing product information. Please contact support.',
] as const satisfies TranslationKey;

export const LANDING_PAGE_LOADING_PAGE = [
  'common:landing_page.loading_page',
  'Loading page...',
] as const satisfies TranslationKey;

export const LANDING_PAGE_OFFER_SELECTOR_ARIA = [
  'common:landing_page.offer_selector_aria',
  'Offer selector',
] as const satisfies TranslationKey;

export const LANDING_PAGE_SAVE = [
  'common:landing_page.save',
  'Save {{amount}}',
] as const satisfies TranslationKey;

export const LANDING_PAGE_WITHOUT_CHROME_ARIA = [
  'common:landing_page.without_chrome_aria',
  'Landing page without funnel chrome',
] as const satisfies TranslationKey;

export const NOT_FOUND_PAGE_TITLE = [
  'common:not_found_page.title',
  'Page not found',
] as const satisfies TranslationKey;

export const NOT_FOUND_PAGE_DESCRIPTION = [
  'common:not_found_page.description',
  'The page you requested does not exist or is no longer available.',
] as const satisfies TranslationKey;

export const NOT_FOUND_PAGE_BACK_HOME = [
  'common:not_found_page.back_home',
  'Back to home',
] as const satisfies TranslationKey;

export const PACK_PAGE_INVALID_URL = [
  'pdp:pack_page.invalid_url',
  'Invalid pack URL',
] as const satisfies TranslationKey;

export const PACK_PAGE_BACK_TO_PRODUCTS = [
  'pdp:pack_page.back_to_products',
  '← Back to Products',
] as const satisfies TranslationKey;

export const PACK_PAGE_LOADING = [
  'pdp:pack_page.loading',
  'Loading pack...',
] as const satisfies TranslationKey;

export const PACK_PAGE_NOT_FOUND = [
  'pdp:pack_page.not_found',
  'Pack not found',
] as const satisfies TranslationKey;

export const PACK_PAGE_ADD_ERROR = [
  'pdp:pack_page.add_error',
  "Couldn't add this pack to your cart. Please try again.",
] as const satisfies TranslationKey;

export const POST_PURCHASE_LOADING_PAGE = [
  'common:post_purchase.loading_page',
  'Loading page...',
] as const satisfies TranslationKey;

export const POST_PURCHASE_LOADING_OFFER = [
  'common:post_purchase.loading_offer',
  'Loading your special offer...',
] as const satisfies TranslationKey;

export const POST_PURCHASE_REDIRECTING = [
  'common:post_purchase.redirecting',
  'Redirecting...',
] as const satisfies TranslationKey;

export const PRODUCT_DETAIL_INVALID_URL = [
  'pdp:product_detail.invalid_url',
  'Invalid product URL',
] as const satisfies TranslationKey;

export const PRODUCT_DETAIL_BACK_TO_PRODUCTS = [
  'pdp:product_detail.back_to_products',
  '← Back to Products',
] as const satisfies TranslationKey;

export const SEARCH_RESULTS_BREADCRUMB_HOME = [
  'common:search_results.breadcrumb_home',
  'Home',
] as const satisfies TranslationKey;

export const SEARCH_RESULTS_SEARCH_PLACEHOLDER = [
  'common:search_results.search_placeholder',
  'Search products & bundles...',
] as const satisfies TranslationKey;

export const SEARCH_RESULTS_ERROR = [
  'common:search_results.error',
  'Failed to search products:',
] as const satisfies TranslationKey;

export const SEARCH_RESULTS_SHOWING = [
  'common:search_results.showing',
  'Showing {{count}} of {{total}} products',
] as const satisfies TranslationKey;

export const SEARCH_RESULTS_BUNDLES = [
  'common:search_results.bundles',
  'Bundles',
] as const satisfies TranslationKey;

export const SEARCH_RESULTS_PREVIOUS = [
  'common:search_results.previous',
  'Previous',
] as const satisfies TranslationKey;

export const SEARCH_RESULTS_NEXT = [
  'common:search_results.next',
  'Next',
] as const satisfies TranslationKey;

export const THANK_YOU_TITLE = [
  'common:thank_you.title',
  'Thank You for Your Order!',
] as const satisfies TranslationKey;

export const THANK_YOU_SUBTITLE = [
  'common:thank_you.subtitle',
  'Your order has been placed successfully.',
] as const satisfies TranslationKey;

export const THANK_YOU_ORDER_NUMBER = [
  'common:thank_you.order_number',
  'Order Number',
] as const satisfies TranslationKey;

export const THANK_YOU_CONFIRMATION_EMAIL = [
  'common:thank_you.confirmation_email',
  "We'll send you a confirmation email with your order details and tracking information once your order ships.",
] as const satisfies TranslationKey;

export const THANK_YOU_ORDER_SUMMARY = [
  'common:thank_you.order_summary',
  'Order Summary',
] as const satisfies TranslationKey;

export const THANK_YOU_QTY = [
  'common:thank_you.qty',
  'Qty: {{count}}',
] as const satisfies TranslationKey;

export const THANK_YOU_TOTAL = [
  'common:thank_you.total',
  'Total',
] as const satisfies TranslationKey;

export const THANK_YOU_CONTINUE_SHOPPING = [
  'common:thank_you.continue_shopping',
  'Continue Shopping',
] as const satisfies TranslationKey;

export const PRODUCTS_PAGE_NAV_HOME = [
  'common:navigation.home',
  'Home',
] as const satisfies TranslationKey;

export const PRODUCTS_PAGE_NAV_PRODUCTS = [
  'common:navigation.products',
  'Products',
] as const satisfies TranslationKey;

export const PRODUCTS_PAGE_TITLE = [
  'common:productsPage.title',
  'Our Shapermint Collection',
] as const satisfies TranslationKey;

export const PRODUCTS_PAGE_SUBTITLE = [
  'common:productsPage.subtitle',
  'Discover our best-selling shapewear, bras, and bodysuits',
] as const satisfies TranslationKey;

export const PRODUCTS_PAGE_PRODUCT_COUNT = [
  'common:productsPage.productCount',
  '— {{count}} products',
] as const satisfies TranslationKey;

export const PRODUCTS_PAGE_ERROR_LOADING = [
  'common:productsPage.errorLoading',
  'Failed to load products: {{error}}',
] as const satisfies TranslationKey;

export const PRODUCTS_PAGE_LOADING = [
  'common:productsPage.loading',
  'Loading products...',
] as const satisfies TranslationKey;
